<template>
  <div
    :id="renderTo"
    class="yandex-block"
    :class="isHeader ? 'yandex-block__header' : 'yandex-block'"
  />
</template>

<script setup lang="ts">
import { useInteractiveStore } from '~/stores/interactive';

const interactiveStore = useInteractiveStore();
const isPageSpeedBot = computed(() => interactiveStore.isPageSpeedBot);
const count = ref(1);
const props = defineProps({
  blockId: {
    type: String,
    default: 'R-A-7399841-3',
  },
  renderTo: {
    type: String,
    default: 'yandex_rtb_R-A-7399841-3',
  },
  type: {
    type: String,
    default: '',
  },
  platform: {
    type: String,
    default: '',
  },
  isHeader: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['error']);
const renderYa = () => {
  if (window.yaContextCb && window?.Ya?.Context?.AdvManager) {
    window.yaContextCb.push(() => {
      window.Ya.Context.AdvManager.render({
        blockId: props.blockId,
        renderTo: props.renderTo,
        onError,
        ...(props.type ? { type: props.type } : {}),
        ...(props.platform ? { platform: props.platform } : {}),
      });
    });
  } else if (count.value < 10) {
    setTimeout(() => {
      renderYa();
      count.value = count.value + 1;
    }, 700);
  }
};
const setFixHeight = () => {
  const promoHeight =
    document?.getElementById(props.renderTo)?.clientHeight || 0;
  document.documentElement.style.setProperty(
    '--promobannerheight',
    promoHeight ? promoHeight + 'px' : '0px'
  );
};

const onError = () => {
  emit('error');
};

onMounted(() => {
  if (!isPageSpeedBot.value) {
    renderYa();
    if (props.isHeader) {
      setTimeout(() => setFixHeight(), 300);
    }
  }
});
onBeforeUnmount(() => {
  if (window?.Ya?.Context?.AdvManager) {
    window?.Ya?.Context?.AdvManager.destroy({
      blockId: props.blockId,
    });
  }
});
</script>

<style scoped lang="scss">
.yandex-block {
  width: 100%;
  max-height: 120px;
  overflow: hidden;
  border-radius: 8px;
  &__header {
    position: sticky;
    top: 0;
    display: block;
    width: 100%;
    height: 50px;
    overflow: hidden;
    border-radius: 0;
    background-color: white;
    z-index: 100;
    @include xl-block {
      display: none;
      position: relative;
      max-height: unset;
      height: 0;
    }
  }
  @include xl-block {
    position: relative;
    max-height: 160px;
  }
}
</style>
